import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { NotificationProvider } from "../shared/ui/index.js";
import { QuickviewPage } from "../features/quickview/ui/QuickviewPage.js";

const EditorPage = lazy(() =>
  import("../features/tactic-editor/ui/EditorPage.js").then((module) => ({
    default: module.EditorPage,
  })),
);
const LoginPage = lazy(() =>
  import("../features/tactic-editor/ui/LoginPage.js").then((module) => ({
    default: module.LoginPage,
  })),
);
const PasswordPage = lazy(() =>
  import("../features/tactic-editor/ui/PasswordPage.js").then((module) => ({
    default: module.PasswordPage,
  })),
);
const GrenadeCatalogPage = lazy(() =>
  import("../features/grenade-catalog/ui/GrenadeCatalogPage.js").then(
    (module) => ({ default: module.GrenadeCatalogPage }),
  ),
);

export function App() {
  return (
    <NotificationProvider>
      <Routes>
        <Route path="/" element={<QuickviewPage />} />
        <Route
          path="/editor"
          element={
            <Suspense
              fallback={<div className="route-loading">EDITOR LÄDT …</div>}
            >
              <EditorPage />
            </Suspense>
          }
        />
        <Route
          path="/granaten"
          element={
            <Suspense
              fallback={<div className="route-loading">KATALOG LÄDT …</div>}
            >
              <GrenadeCatalogPage />
            </Suspense>
          }
        />
        <Route
          path="/editor/login"
          element={
            <Suspense
              fallback={<div className="route-loading">LOGIN LÄDT …</div>}
            >
              <LoginPage />
            </Suspense>
          }
        />
        <Route
          path="/editor/passwort"
          element={
            <Suspense
              fallback={<div className="route-loading">SEITE LÄDT …</div>}
            >
              <PasswordPage />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </NotificationProvider>
  );
}
